module.exports = __webpack_public_path__ + "static/media/sound.eb4e2312.mp3";